import {IComboBoxStyles, IContextualMenuStyles, IDatePickerStyles, IDropdownStyles} from "office-ui-fabric-react";

/**
 * Fluent UI Callouts don't work with standard SCSS global styling because they are processed separately from the
 * main stylesheet. Due to this restraint, dark mode styling has to be handled programmatically here.
 * For more information about moving away from SCSS and the motivations, please see: https://github.com/microsoft/fluentui/wiki/Component-Styling
 */
export class DarkModeCalloutStyles {
    public static getDatePickerStyle(): IDatePickerStyles {
        return {
            root: {},
            textField: {},
            icon: {},
            callout: {
                selectors: {
                    "& .ms-DatePicker-picker": {backgroundColor: "black"},
                    "& .ms-DatePicker-day--outfocus": {color: "rgb(161, 159, 157)"},
                    "& .ms-DatePicker-day--infocus": {color: "white"},
                    "& .ms-DatePicker-monthOption": {color: "white"},
                    "& .ms-DatePicker-monthAndYear": {color: "white"},
                    "& .ms-DatePicker-weekday": {color: "white"},
                    "& .ms-DatePicker-prevMonth": {color: "white"},
                    "& .ms-DatePicker-nextMonth": {color: "white"},
                    "& .ms-DatePicker-currentYear": {color: "white"},
                    "& .ms-DatePicker-prevYear": {color: "white"},
                    "& .ms-DatePicker-nextYear": {color: "white"},
                    "& .ms-DatePicker-currentDecade": {color: "white"},
                    "& .ms-DatePicker-yearOption": {color: "white"},
                    "& .ms-DatePicker-prevDecade": {color: "white"},
                    "& .ms-DatePicker-nextDecade": {color: "white"},
                    "& .ms-DatePicker-goToday": {color: "white"},
                    "& .ms-DatePicker-goToday:hover": {color: "rgb(93, 93, 93)"},
                    "& .ms-DatePicker-goToday:disabled": {color: "rgb(93, 93, 93)"},
                    "& .ms-DatePicker-day:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-yearOption:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-currentDecade:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-prevMonth:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-nextMonth:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-currentYear:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-prevYear:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-nextYear:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-monthOption:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-prevDecade:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-nextDecade:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white"},
                    "& .ms-DatePicker-day--highlighted": {backgroundColor: "rgb(93, 93, 93) !important"},
                },
            },
        };
    }

    public static getDropdownStyle(): IDropdownStyles {
        return {
            root: {},
            label: {},
            dropdown: {},
            title: {},
            caretDownWrapper: {},
            caretDown: {},
            errorMessage: {},
            dropdownItemsWrapper: {},
            dropdownItems: {},
            dropdownItem: {},
            dropdownItemSelected: {},
            dropdownItemDisabled: {},
            dropdownItemSelectedAndDisabled: {},
            dropdownItemHidden: {},
            dropdownOptionText: {},
            dropdownDivider: {},
            dropdownItemHeader: {},
            panel: {},
            callout: {
                selectors: {
                    "& .ms-Dropdown-item": {backgroundColor: "black", color: "white"},
                    "& .ms-Dropdown-item:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white !important"},
                },
            },
            subComponentStyles: {
                panel: {},
                label: {},
                multiSelectItem: {},
            },
        };
    }

    public static getComboBoxStyles(): IComboBoxStyles {
        return {
            container: {},
            label: {},
            labelDisabled: {},
            root: {},
            rootError: {},
            rootDisallowFreeForm: {},
            rootHovered: {},
            rootPressed: {},
            rootFocused: {},
            rootDisabled: {},
            input: {},
            inputDisabled: {},
            errorMessage: {},
            callout: {
                selectors: {
                    "& .ms-ComboBox-option": {backgroundColor: "black", color: "white"},
                    "& .ms-ComboBox-option:hover": {backgroundColor: "rgb(93, 93, 93)", color: "white !important"},
                },
            },
            optionsContainerWrapper: {},
            optionsContainer: {},
            header: {},
            divider: {},
            screenReaderText: {},
        };
    }

    public static getContextualMenuCalloutStyles(): IContextualMenuStyles {
        return {
            title: {},
            container: {},
            header: {},
            list: {},
            root: {},
            subComponentStyles: {
                callout: {
                    root: {
                        selectors: {
                            "& .ms-ContextualMenu-itemText": {color: "white !important"},
                            "& .ms-Callout-main": {backgroundColor: "black"},
                            "& .ms-Callout-main:hover *": {backgroundColor: "rgb(93, 93, 93)"},
                            "& .ms-Callout-beak": {backgroundColor: "black"},
                            "& .ms-BaseButton-menuhost": {backgroundColor: "black"},
                        },
                    },
                },
                menuItem: {},
            },
        };
    }
}
